export const experience = {
  type: "Internship",
  place: "Municipality Of Skydra",
  date: "07/2017 - 08/2017",
  task1:
    "Configured hardware, devices and software to set up work stations for employees",
  task2: "Provided technical support and feedback to employees",
  seminar1: "Entrepreneurship Seminars",
  seminar1place: "University of Thessaly",
  seminar1date: "09/2017 - 06/2018)",
  seminar1desc:
    "Basic Knowledge in Entrepreneurship and 1 year of group work on innovative ideas",
  seminar2: "MySQL Bootcamp",
  seminar2desc: "Developing SQL in MySQL RDBMS",
  seminar2place: "Udemy",
  seminar2date: "07/2020 - 07/2020",
};
